document.addEventListener('DOMContentLoaded', () => {
  const variantDataElement = document.querySelector('[id^="BackorderVariants-"]');
  const backorderMessage = document.querySelector('[id^="BackorderMessage-"]');
  const variantInput = document.querySelector(
    'form[action="/cart/add"] input[name="id"]'
  );

  if (!variantDataElement || !backorderMessage || !variantInput) return;

  const variants = JSON.parse(variantDataElement.textContent);

  function updateBackorderMessage() {
    const variant = variants.find(
      v => v.id === Number(variantInput.value)
    );

    const showMessage =
      variant &&
      variant.inventory_quantity < 1 &&
      variant.inventory_policy === 'continue';

    backorderMessage.hidden = !showMessage;
  }

  updateBackorderMessage();

  variantInput.addEventListener('change', updateBackorderMessage);
});